
import { localStorage } from '@utils/basicUtil'
import moment from 'moment'

export default {
  namespace: 'invoice',
  state: {
    ossUrlList: [],
    showChoice: false,
    showGuide: localStorage.get('showGuide'),
    infoInvoice: {},
    formData: {
      proxyFlag: 0,
      invoiceType: null,
      purchaserName: '',
      purchaserTaxNo: '',
      purchaserAddress: '',
      purchaserBankName: '',
      takeDate: '',
      purchaserPhone: '',
      taker: '',
      takerIdCard: '',
      takerTelephone: '',
      logisticsFlag: '1',
      elementCode: '',
      specificElementVOs: [],
      notes: '',
      remark: '',
      money: '0',
      files: [],
      receiverName: '',
      receiverAddress: '',
      receiverPhone: '',
      receiverEmail: '',
      deptId: '',
      deptName: ''
    },
    goodsList: [],
    merchantId: undefined,
    merchantInfo: {
      addresseeInfoRequestList: [],
      merchantArchivesVo: {
        id: '',
        company: '',
        nature: 1,
        taxNo: '',
        address: '',
        bankName: '',
        email: '',
        enable: 0
      }
    },
    smartInvoiceLimits: localStorage.get('invoiceLimits'),
    smartApplyData: {
      proxyFlag: 0,
      invoiceType: null,
      purchaserName: '',
      purchaserTaxNo: '',
      purchaserAddress: '',
      purchaserBankName: '',
      logisticsFlag: '1',
      money: '0',
      receiverName: '',
      receiverAddress: '',
      receiverEmail: '',
      receiverPhone: ''
    },
    smartGoodsList: [],
    smartMerchantId: undefined,
    smartMerchantInfo: {
      addresseeInfoRequestList: [],
      merchantArchivesVo: {
        id: '',
        company: '',
        nature: 1,
        taxNo: '',
        address: '',
        bankName: '',
        email: '',
        enable: 0
      }
    },
    invoiceImageData: {},
    businessGoodsList: [],
    businessApplyData: {
      money: '0',
      remark: '',
      elementCode: '',
      defaultIndex: 0,
      invoiceTypeDefaultIndex: 0,
      invoiceType: 3
    },
    invoiceHomeApplySearch: {
      searchParams: {
        size: 25,
        current: 1,
        purchaserName: '',
        status: undefined
      },
      searchOptions: {
        applyDate: undefined
      }
    },
    invoiceHomeInvoiceSearch: {
      searchParams: {
        size: 25,
        current: 1,
        purchaserName: '',
        invoiceStatus: undefined
      },
      searchOptions: {
        applyDate: undefined
      }
    },
    incomeHomeSearch: {
      searchParams: {
        size: 25,
        current: 1,
        desc: 'createTime',
        name: '',
        commitFlag: '',
        isItTrue: '',
        startTime: '',
        endTime: ''
      },
      searchOptions: {
        invoiceStatus: undefined,
        applyDate: undefined
      }
    },
    invoiceOpeningInfo: {
      invoiceType: 3,
      invoiceSource: 3,
      settlementSource: 5,
      printFlag: 0,
      billingType: 0,
      isPayInvoice: 2,
      taxSignFlag: true,
      drewDate: moment().format('YYYY-MM-DD')
    }
  },
  mutations: {
    changeInvoiceOpeningInfo (state, { field, value }) {
      state.invoiceOpeningInfo = {
        ...state.invoiceOpeningInfo,
        [field]: value
      }
    },
    replaceInvoiceOpeningInfo (state, invoiceOpeningInfo) {
      state.invoiceOpeningInfo = {
        ...invoiceOpeningInfo,
        invoiceSource: 3,
        settlementSource: 5,
        printFlag: 0,
        billingType: 0,
        taxSignFlag: true,
        isPayInvoice: 2,
        drewDate: moment().format('YYYY-MM-DD')
      }
    },
    initInvoiceOpeningInfo (state) {
      state.invoiceOpeningInfo = {
        invoiceType: 3,
        invoiceSource: 3,
        settlementSource: 5,
        printFlag: 0,
        billingType: 0,
        taxSignFlag: true,
        isPayInvoice: 2,
        drewDate: moment().format('YYYY-MM-DD')
      }
    },
    changeOssUrlList (state, ossUrlList) {
      state.ossUrlList = ossUrlList
    },
    changeInfoInvoice (state, infoInvoice) {
      state.infoInvoice = infoInvoice
    },
    changeSmartInvoiceLimits (state, smartInvoiceLimits) {
      state.smartInvoiceLimits = smartInvoiceLimits
    },
    changeProxyFlag (state, proxyFlag) {
      state.formData.proxyFlag = proxyFlag
    },
    changeApplyData (state, { formData }) {
      state.formData = {
        ...state.formData,
        ...formData
      }
    },
    initApplyData (state) {
      let invoiceLimits = localStorage.get('invoiceLimits')
      let invoiceType = '1'
      if (invoiceLimits) {
        const res = invoiceLimits.split(',')
        invoiceType = res[0]
      }
      state.formData = {
        proxyFlag: 0, // 0 自有税盘 1 税局代开
        invoiceType: invoiceType,
        purchaserName: '',
        purchaserTaxNo: '',
        purchaserAddress: '',
        purchaserBankName: '',
        logisticsFlag: '1',
        elementCode: '',
        specificElementVOs: [],
        takeDate: '',
        taker: '',
        takerIdCard: '',
        takerTelephone: '',
        notes: '',
        remark: '',
        money: '0',
        files: [],
        receiverName: '',
        receiverAddress: '',
        receiverPhone: '',
        receiverEmail: ''
      }
    },
    changeGoodsList (state, goodsList) {
      state.goodsList = goodsList
    },
    changeSmartApplyData (state, { data }) {
      state.smartApplyData = {
        ...state.smartApplyData,
        ...data
      }
    },
    initSmartApplyData (state) {
      state.smartApplyData = {
        proxyFlag: 0,
        invoiceType: null,
        purchaserName: '',
        purchaserTaxNo: '',
        purchaserAddress: '',
        purchaserBankName: '',
        logisticsFlag: '1',
        money: '0',
        receiverName: '',
        receiverAddress: '',
        receiverPhone: ''
      }
    },
    changeSmartGoodsList (state, goodsList) {
      state.smartGoodsList = goodsList
    },
    changeShowChoice (state, showChoice) {
      state.showChoice = showChoice
    },
    changeShowGuide (state, showGuide) {
      state.showGuide = showGuide
    },
    changeMerchantId (state, merchantId) {
      state.merchantId = merchantId
    },
    initMerchantInfo (state) {
      state.merchantInfo = {
        addresseeInfoRequestList: [],
        merchantArchivesVo: {
          id: '',
          company: '',
          nature: 1,
          taxNo: '',
          address: '',
          bankName: '',
          email: '',
          enable: 0
        }
      }
    },
    changeMerchantInfo (state, merchantInfo) {
      state.merchantInfo = { ...state.merchantInfo, ...merchantInfo }
    },
    changeDeptInfo (state, deptInfo) {
      state.formData = { ...state.formData, ...deptInfo }
    },
    changeSmartMerchantId (state, merchantId) {
      state.smartMerchantId = merchantId
    },
    initSmartMerchantInfo (state) {
      state.smartMerchantInfo = {
        addresseeInfoRequestList: [],
        merchantArchivesVo: {
          id: '',
          company: '',
          nature: 1,
          taxNo: '',
          address: '',
          bankName: '',
          email: '',
          enable: 0
        }
      }
    },
    changeSmartMerchantInfo (state, merchantInfo) {
      state.smartMerchantInfo = { ...state.smartMerchantInfo, ...merchantInfo }
    },
    changeImage (state, invoiceImageData) {
      state.invoiceImageData = invoiceImageData
    },
    changeBusinessGoodsList (state, goodsList) {
      state.businessGoodsList = goodsList
    },
    changeBusinessApplyData (state, { data }) {
      state.businessApplyData = {
        ...state.businessApplyData,
        ...data
      }
    },
    saveInvoiceHomeApplySearch (state, params) {
      state.invoiceHomeApplySearch = params
    },
    initInvoiceHomeApplySearch (state) {
      state.invoiceHomeApplySearch = {
        searchParams: {
          size: 25,
          current: 1,
          purchaserName: '',
          status: undefined
        },
        searchOptions: {
          applyDate: undefined
        }
      }
    },
    saveInvoiceHomeInvoiceSearch (state, params) {
      state.invoiceHomeInvoiceSearch = params
    },
    initInvoiceHomeInvoiceSearch (state) {
      state.invoiceHomeInvoiceSearch = {
        searchParams: {
          size: 25,
          current: 1,
          purchaserName: '',
          invoiceStatus: undefined
        },
        searchOptions: {
          applyDate: undefined
        }
      }
    },
    saveIncomeHomeSearch (state, params) {
      state.incomeHomeSearch = params
    },
    initIncomeHomeSearch (state) {
      state.incomeHomeSearch = {
        searchParams: {
          size: 25,
          current: 1,
          desc: 'createTime',
          name: '',
          commitFlag: '',
          isItTrue: '',
          startTime: '',
          endTime: ''
        },
        searchOptions: {
          invoiceStatus: undefined,
          applyDate: undefined
        }
      }
    }
  },
  actions: {}
}
